import React, { Component } from 'react';
import Layout from '../../../Layouts/DefaultLayout';
import { Breadcrumb, Row, Col, Container, Image } from 'react-bootstrap';
import * as PartnerActions from '../../../../redux/partners/actions';
import ExplorePartners from '../../../Layouts/Partials/ExplorePartners';



class PartnerViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            data: null
        }
    }

    componentDidMount = async () => {
        let slug = this.props.match.params.id;
        if (slug !== undefined) {
            this._loadPartner(slug);
        } else {
            this.backToList();
        }
    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }

    _loadPartner = async (slug) => {
        this.setState({ isLoading: true });
        let resp = await PartnerActions.searchPartnerJson(this.props.token, slug);
        if (resp.state) {
            this.setState({ isLoading: false, data: resp.data });
        } else {
            this.setState({ isLoading: false }, () => this.backToList());
        }
    }

    backToList = () => {
        this.props.history.push(`/partners`);
    }


    render = () => {
        let partner = this.state.data;

        return (
            <Layout>

                {(partner !== null) && (
                    <React.Fragment>
                        <Container>
                            <Breadcrumb className="mt-4">
                                <Breadcrumb.Item href="/partners">{`Partners`}</Breadcrumb.Item>
                                <Breadcrumb.Item href={`/partners/${partner.post_name}`}>{`${partner.post_name}`}</Breadcrumb.Item>
                            </Breadcrumb>
                            <h1>{partner.post_title}</h1>
                            <Row>
                                <Col md={3}>
                                    {(partner.logo !== null && partner.logo !== undefined && partner.logo !== false) && (
                                        <Image src={partner.logo.sizes['logo']} fluid />
                                    )}

                                </Col>
                                <Col md={9}>
                                    {(partner.headerimage !== null && partner.headerimage !== undefined && partner.headerimage !== false) && (
                                        <Image src={partner.headerimage.sizes['thumbnail']} fluid />
                                    )}
                                </Col>
                            </Row>
                            <h3 className="text-center my-4">About {partner.post_title}</h3>
                            <Row className="mb-5">
                                <Col md={{ span: 8, offset: 2 }}>
                                    {this._renderBody(partner.post_content)}
                                    {
                                        partner.website &&
                                        <a className="mt-4 btn btn-primary btn-block" href={partner.website} target="_blank" >Visit our website</a>
                                    }
                                </Col>
                            </Row>
                        </Container>
                        <Container fluid>
                        <Row className="expore-more-container">
                            <Col xs={12}>
                                    <ExplorePartners
                                        currentPartnerID={partner.ID}
                                        token={this.props.token}
                                    />
                            </Col>
                        </Row>
                        </Container>
                    </React.Fragment>
                )}
            </Layout>
        );
    };

    _renderBody = (data) => {
        let res = data.replace(/oembed url="https:\/\/www\.youtube\.com\/watch\?v=/g, function ($1, $2) {
            return "iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/"
        })
        res = res.replace(/oembed/g, 'iframe')    
            
        return (
            <div dangerouslySetInnerHTML={{ __html: res }}></div>
        )
    }

}


/* Export Component ==================================================================== */
export default PartnerViewContainer;